import { connector } from "../../utils/common/connector";

const controller = "customer";

// ---------------------------------------------
// GET CUSTOMERS (GENERAL)
// ---------------------------------------------
export const getCustomersService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getCustomers", params);

    reply = {
      customers: response?.customers ?? [],
      totalCustomers: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
      totalCustomers: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET TOP CUSTOMERS
// ---------------------------------------------
export const getTopCustomersByCompanyAndCategoryService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getTopCustomersByCompanyAndCategory",
      params,
    );

    reply = {
      customers: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CUSTOMER BY ID
// ---------------------------------------------
export const getCustomerByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getCustomer", params);

    reply = {
      customer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      customer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CUSTOMER
// ---------------------------------------------
export const updateCustomerService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "updateCustomer", params);

    reply = {
      customer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      customer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CUSTOMER
// ---------------------------------------------
export const createCustomerService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newCustomer", params);

    reply = {
      customer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      customer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE MULTIPLE CUSTOMERS
// ---------------------------------------------
export const createCustomersService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newCustomers", params);

    reply = {
      customers: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CUSTOMERS BY LIST
// ---------------------------------------------
export const getCustomersByListService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getCustomers", {
      customerListId: params?.listId,
      page: params?.page,
      pageSize: params?.pageSize,
      search: params?.search,
    });

    reply = {
      customers: response?.customers ?? [],
      totalCustomers: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
      totalCustomers: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// ADD CUSTOMER TO LIST
// ---------------------------------------------
export const addCustomerToListService = async (params) => {
  let reply;

  try {
    const response = await connector.post(
      controller,
      "addCustomerToList",
      params,
    );

    reply = {
      customer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      customer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// REMOVE CUSTOMER FROM LIST
// ---------------------------------------------
export const removeCustomerFromListService = async (params) => {
  let reply;

  try {
    const response = await connector.post(
      controller,
      "removeCustomerFromList",
      params,
    );

    reply = {
      customer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      customer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET REFERRED OPTIONS
// ---------------------------------------------
export const getCustomersReferredOptionsService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getCustomersReferredOptions",
      {
        ...params,
        excludeIds: JSON.stringify(params?.excludeIds || []),
      },
    );

    reply = {
      customers: response?.customers ?? [],
      totalCustomers: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
      totalCustomers: 0,
    };
  }

  return reply;
};
